import { prepareOktaSessionBeforeRender } from '@/utils/okta/oktaAuth'

export const bootstrapApplication = async (
  renderApplication: () => void,
  prepareSession: () => Promise<boolean> = prepareOktaSessionBeforeRender,
): Promise<boolean> => {
  let ready = true
  try {
    ready = await prepareSession()
  } catch {
    // Unexpected bootstrap failures must not leave the whole application blank.
  }
  if (!ready) return false

  renderApplication()
  return true
}
